import { render, staticRenderFns } from "./UniverseCustomers.vue?vue&type=template&id=2e3f7819"
import script from "./UniverseCustomers.vue?vue&type=script&lang=js"
export * from "./UniverseCustomers.vue?vue&type=script&lang=js"
import style0 from "./UniverseCustomers.vue?vue&type=style&index=0&id=2e3f7819&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports